export const getPercentageFormat = (value,decimal=2) => {
  if (typeof value !== 'number' || isNaN(value)) {
        return `${0.00}%`;
    }
    else {
        const percentage = (value * 100).toFixed(decimal);
        return `${percentage}%`;
    }
};
export const getPercentageValueFormat = (value) => {
  if (typeof value !== 'number' || isNaN(value)) {
      return `${0.00}%`;
  }
  else {
      const percentage = (value).toFixed(2);
      return `${percentage}%`;
  }
};
export const getCurrencyFormat=(number,decimalnumber, currencyCode = 'USD', locale = 'en-US')=>{
    try {
        const formattedCurrency = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: decimalnumber,
          maximumFractionDigits: decimalnumber,
        }).format(number);
    
        return formattedCurrency;
      } catch (error) {
        console.error('Error formatting currency:', error);
        return 'Error';
      }
}